import React, {
  useContext,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import { createGlobalStyle } from 'styled-components';
import CartContext from '../../contexts/CartContext';

import Iframe from '../Iframe';

import { ReactComponent as Close } from '../../common/icons/chevronDown.svg';
import GiftIcon from '../../common/icons/GiftIcon';
import { Notification } from './Notification';
import { LauncherIcon } from './LauncherIcon';
import isMobile from '../../common/utils/isMobile';
import AnimationContext from '../../contexts/AnimationContext';
import colors from 'tailwindcss/colors'

export default ({
  open,
  toggle,
  remainingOffers,
  theme,
  tracker,
  offers,
  settings,
  hasUnselectedOffers,
}) => {
  const { cart } = useContext(CartContext);
  const CustomCss = createGlobalStyle`${settings.custom_css}` as FunctionComponent;
  const animationContext = useContext(AnimationContext)
  const [previousOpenState, setPreviousOpenState] = useState(false);
  const [giftIconClass, setGiftIconClass] = useState('');
  const [closeIconClass, setCloseIconClass] = useState('');

  useEffect(() => {
    if (previousOpenState !== open) {
      setGiftIconClass(open ? 'fadeOut' : 'fadeInLauncher');
      setCloseIconClass(open ? 'fadeInClose' : 'fadeOut');
    }
    setPreviousOpenState(open);
  }, [open]);

  return (
    <Iframe
      data-cy="launcher"
      bottomSpacing={settings.bottom_spacing}
      sideSpacing={settings.side_spacing}
      alignLeft={theme.alignLeft}
      theme={theme}
      isHidden={open && isMobile()}
    >
      <div className="Launcher-Content flex">
        <div className="launcherContainer launcherIntro left-2 relative m-auto rounded-full">
          <Notification
            remainingOffers={remainingOffers}
            hasUnselectedOffers={hasUnselectedOffers}
          />
          <div
            className="GiftBox-Launcher flex justify-center items-center text-white cursor-pointer rounded-full absolute"
            onClick={() => {
              if (open) {
                tracker.trackLauncherClickClose(cart);
                toggle()
              } else {
                tracker.trackLauncherClickOpen(offers, cart);
                animationContext.triggerWithAnimation?.({
                  name: isMobile() ? 'open_popup_mobile' : 'open_popup_desktop',
                  delayMsBefore: 200,
                  delayMsAfter: 0,
                  callback: toggle
                })
              }
            }}
          >
            <LauncherIcon
              color={settings?.background_color ?? '#282a2c'}
              className="absolute top-0 right-0 bottom-0 left-0"
            />
            {window.GIFTBOX_CUSTOM_LAUNCHER_ICON ? (
              <img
                src={window.GIFTBOX_CUSTOM_LAUNCHER_ICON}
                alt="custom launcher giftIcon"
                className="h-3 w-3 launcher"
              />
            ) : (
              <GiftIcon
                className={`${giftIconClass} absolute`}
                color={settings?.primary_color ?? colors.white}
              />
            )}
            <Close
              height="32"
              width="32"
              className={`${closeIconClass}`}
              fill={settings?.primary_color ?? colors.white}
            />
          </div>
        </div>
        <CustomCss />
      </div>
    </Iframe>
  );
};
